import React from 'react';
import { string } from 'prop-types';

function Loading({ label }) {
  return (
    <div
      aria-label={label}
      className="loading"
      role="alert"
      aria-live="assertive"
    >
      <div className="loading__fading-circle">
        <div className="loading__circle" />
        <div className="loading__circle loading__circle--2" />
        <div className="loading__circle loading__circle--3" />
        <div className="loading__circle loading__circle--4" />
        <div className="loading__circle loading__circle--5" />
        <div className="loading__circle loading__circle--6" />
        <div className="loading__circle loading__circle--7" />
        <div className="loading__circle loading__circle--8" />
        <div className="loading__circle loading__circle--9" />
        <div className="loading__circle loading__circle--10" />
        <div className="loading__circle loading__circle--11" />
        <div className="loading__circle loading__circle--12" />
      </div>
    </div>
  );
}

Loading.propTypes = {
  label: string.isRequired
};

export default Loading;
